export const HULL_01 = { uid: 'pure_silver', name: "Pure Silver", filename: "PureSilver.png", group: "metallic" };
export const HULL_02 = { uid: 'stardust_silver', name: "Stardust Silver", filename: "StardustSilver.png", group: "metallic" };
export const HULL_03 = { uid: 'diamond_gray', name: "Diamond Gray", filename: "DiamondGray.png", group: "metallic" };
export const HULL_04 = { uid: 'ahamay_gray', name: "Ahamay Gray", filename: "AhamayGray.png", group: "metallic" };
export const HULL_05 = { uid: 'pale_gold', name: "Pale Gold", filename: "PaleGold.png", group: "metallic" };
export const HULL_06 = { uid: 'mocha_brown', name: "Mocha Brown", filename: "MochaBrown.png", group: "metallic" };
export const HULL_07 = { uid: 'sahara_gold', name: "Sahara Gold", filename: "SaharaGold.png", group: "metallic" };
export const HULL_08 = { uid: 'royal_rubie', name: "Royal Rubie", filename: "RoyalRubie.png", group: "metallic" };
export const HULL_09 = { uid: 'sunstone_red', name: "Sunstone Red", filename: "SunstoneRed.png", group: "metallic" };
export const HULL_10 = { uid: 'dolphin_blue', name: "Dolphine Blue", filename: "DolphineBlue.png", group: "metallic" };
export const HULL_11 = { uid: 'palma_blue', name: "Palma Blue", filename: "PalmeBlue.png", group: "metallic" };
export const HULL_12 = { uid: 'lagoon_blue', name: "Lagoon Blue", filename: "LagoonBlue.png", group: "metallic" };
export const HULL_13 = { uid: 'blue_topaz', name: "Blue Topaz", filename: "BlueTopaz.png", group: "metallic" };
export const HULL_14 = { uid: 'velvet_green', name: "Velvet Green", filename: "VelvetGreen.png", group: "metallic" };
export const HULL_15 = { uid: 'luna_green', name: "Luna Green", filename: "LunaGreen.png", group: "metallic" };
export const HULL_16 = { uid: 'cloud_white', name: "Cloud White", filename: "CloudWhite.png", group: "unicolors" };
export const HULL_17 = { uid: 'carina_white', name: "Carina White", filename: "CarinaWhite.png", group: "unicolors" };
export const HULL_18 = { uid: 'light_gray', name: "Light Gray", filename: "LightGray.png", group: "unicolors" };
export const HULL_19 = { uid: 'warm_gray', name: "Warm Gray", filename: "WarmGray.png", group: "unicolors" };
export const HULL_20 = { uid: 'moon_dust', name: "Moon Dust", filename: "MoonDust.png", group: "unicolors" };
export const HULL_21 = { uid: 'buffalo_brown', name: "Buffola Brown", filename: "BuffolaBrown.png", group: "unicolors" };
export const HULL_22 = { uid: 'stingray_gray', name: "Stingray Gray", filename: "StingrayGray.png", group: "unicolors" };
export const HULL_23 = { uid: 'storm_blue', name: "Storm Blue", filename: "StormBlue.png", group: "unicolors" };
export const HULL_24 = { uid: 'petrol_blue', name: "Patrol Blue", filename: "PatrolBlue.png", group: "unicolors" };
export const HULL_25 = { uid: 'bimini_blue', name: "Bimini Blue", filename: "BiminiBlue.png", group: "unicolors" };
export const HULL_26 = { uid: 'capri_blue', name: "Capri Blue", filename: "CapriBlue.png", group: "unicolors" };
export const HULL_27 = { uid: 'forest_green', name: "Forrest Green", filename: "ForrestGreen.png", group: "unicolors" };
export const HULL_28 = { uid: 'sunfast_red', name: "Sunfast Red", filename: "SunfastRed.png", group: "unicolors" };
export const HULL_29 = { uid: 'wine_red', name: "Wine Red", filename: "WineRed.png", group: "unicolors" };
export const HULL_30 = { uid: 'international_orange', name: "Int. Orange", filename: "IntOrange.png", group: "unicolors" };
export const HULL_31 = { uid: 'light_sapphire_blue', name: "Light Sapphire Blue", filename: "LightSapphireBlue.png", group: "metallic" };
export const HULL_32 = { uid: 'ibizia_blue', name: "Ibizia Blue", filename: "IbiziaBlue.png", group: "metallic" };
export const HULL_33 = { uid: 'midnight_gray', name: "Midnight Gray", filename: "MidnightGray.png", group: "metallic" };
export const HULL_34 = { uid: 'anniversary_silver', name: "Anniversary Silver", filename: "AnniversarySilver.png", group: "metallic" };
export const HULL_35 = { uid: 'aurora_gold', name: "Aurora Gold", filename: "AuroraGold.png", group: "metallic" };
export const HULL_ALL = [
    HULL_01,
    HULL_02,
    HULL_03,
    HULL_04,
    HULL_05,
    HULL_06,
    HULL_07,
    HULL_08,
    HULL_09,
    HULL_10,
    HULL_11,
    HULL_12,
    HULL_13,
    HULL_14,
    HULL_15,
    HULL_31,
    HULL_32,
    HULL_33,
    HULL_34,
    HULL_35,
    HULL_16,
    HULL_17,
    HULL_18,
    HULL_19,
    HULL_20,
    HULL_21,
    HULL_22,
    HULL_23,
    HULL_24,
    HULL_25,
    HULL_26,
    HULL_27,
    HULL_28,
    HULL_29,
    HULL_30,
];
